export default __webpack_public_path__ + "static/media/player_0.18d4a2ad.png";